import * as actionTypes from './actionTypes';
import { initialValues } from '../util';
import store from '../store';

export const intializeBrokerQryFunc = (payload) => {
    // Always use a fresh object so reopen/reset never reuses a mutated singleton.
    const _payload = payload
        ? {
            ...payload,
            qryInput: { ...(payload.qryInput || {}) },
            qryOutput: { ...(payload.qryOutput || {}) },
          }
        : initialValues();
    _payload.timer = new Date().getTime();
    if (_payload.saveTo === undefined) {
        // API/mock results omit saveTo — keep createActorRefOnly so the MID form stays open
        const current = store.getState && store.getState().QryInput;
        _payload.saveTo = (payload && current && current.saveTo != null) ? current.saveTo : null;
    }
    if (_payload.requestid === undefined) {
        const current = store.getState && store.getState().QryInput;
        _payload.requestid = (payload && current && current.requestid != null) ? current.requestid : null;
    }
    return {
        type: actionTypes.INIT_QRY_FUNCTION,
        payload: _payload
    }
}

export const setLoadingState = () => {
    return {
        type: 'SET_LOADER_STATE'
    }
}

export const unsetLoadingState = () => {
    return {
        type: 'UNSET_LOADER_STATE'
    }
}

export const setRequestId = (reqId) => {
    const lowerEnv = (window.BASE_URL || "").match(/(staging|dev|stage|qat)/g);
    return {
        type: 'SET_REQUEST_ID',
        requestid: reqId.requestid,
        searchParams: reqId.searchParams,
        mockResponseRequired: !!lowerEnv
    }
}

export const setMockResponse = (recordList, payload) => {
    return {
        type: 'SET_MOCK_RESPONSE',
        payload: {
            qryType: payload.qryType,
            requestid: payload.requestid,
            searchParam: payload.searchParams,
            recordList: recordList,
            payload:payload,
        }
    }
}

export const fileQryFunction = (payload) => {
    return {
        type: actionTypes.FILE_QRY_FUNCTION,
        brokerId: payload.brokerId,
        shipmentId: payload.shipmentId || null,
        useKNCred: payload.useKNCred,
        mot: payload.mot,
        qryType: payload.qryType,
        params: payload.params,
        page: payload.page,
        forReconciliation: payload.forReconciliation || false
    }
}

export const getQryFunction = (shipId, docType, qryType,additionalDataParamtt, hts) => {
    console.log("getQryFunction", shipId, docType, qryType,additionalDataParamtt);
    return {
        type: "GET_QRY_FUNCTION",
        shipId: shipId,
        qryType: qryType,
        docType: docType,
        additionalDataParamtt: additionalDataParamtt,
        hts: hts
    }
}

export const reconcileFunction = (payload) => {
    return {
        type: actionTypes.RECONCILE_FUNCTION,
        shipmentId: payload.shipmentId || null,
        qryType: payload.qryType,
        bolIdData: payload.bolIdData
    }
}
